module.exports = __webpack_public_path__ + "static/media/gangester.932b687e.svg";